// extracted by mini-css-extract-plugin
export default {"logoUwed":"styles_logoUwed__NuKsG"};